import { atom } from "jotai";

// Shared UI state for the mobile drawer that lives in CustomerNavigation.
// Lifted to an atom so the Footer's mobile tab-bar Menu button can open the
// same drawer without prop-drilling state through the layout.
export const isMobileDrawerOpenAtom = atom(false);
